import * as React from 'react'
import { Text } from '@metrisk/react_metrisk-components'
import * as moment from 'moment'
import 'moment-timezone'
import { useIntl } from 'react-intl'

import config from '@app/config'

interface FormClosedNoticeProps {
  campaignDates: {
    startDateTime: string
    endDateTime: string
    daysFromPurchase: number
    daysAfterPurchase: number
    claimFormOpens?: string
  }
}

const FormClosedNotice: React.FC<FormClosedNoticeProps> = ({ campaignDates }) => {
  const start = moment.tz(campaignDates.startDateTime, config.campaign.timezone).local()
  const end = moment.tz(campaignDates.endDateTime, config.campaign.timezone).local()
  const daysBeforeClaim = campaignDates.daysFromPurchase ?? 0
  const daysToClaim = campaignDates.daysAfterPurchase ?? 0
  const claimFormOpens = campaignDates.claimFormOpens ? moment.tz(campaignDates.claimFormOpens, config.campaign.timezone) : start.add(daysBeforeClaim, 'days')
  const claimFormCloses = end.add(daysBeforeClaim + daysToClaim, 'days')
  const intl = useIntl()

  return <div>
    <Text>{intl.formatMessage({ defaultMessage: `The claim form is open between {startDate} and {endDate}`}, { startDate: claimFormOpens.format('L LTS'), endDate: claimFormCloses.format('L LTS') })}</Text>
  </div>
}

export default FormClosedNotice
